import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import cn from 'classnames';

const convertPropToClassName = (prop, className) => prop && className;

class Modal extends Component {
  static Header = ({ children, className, close, closeIcon, ...rest }) => (
    <div className={cn('modal-header', className)} {...rest}>
      {closeIcon && <Icon name="close" onClick={close} />}
      {children}
    </div>
  );

  static Content = ({ children, className, ...rest }) => (
    <div className={cn('modal-content', className)} {...rest}>
      {children}
    </div>
  );

  static Actions = ({ children, className, ...rest }) => (
    <div className={cn('modal-actions', className)} {...rest}>
      {children}
    </div>
  );

  closeModal = (e) => {
    const { ...rest } = this.props;

    return rest.dimmerClick && e.target.id === 'modal'
      ? rest.dimmerClick()
      : false;
  };

  render() {
    const { children, open, basic, className, size, ...rest } = this.props;
    const classes = cn(className, size, convertPropToClassName(basic, 'basic'));

    if (!open) return null;

    return (
      <StyledModal onClick={this.closeModal} id="modal">
        <ModalBody className={classes} {...rest}>
          {children}
        </ModalBody>
      </StyledModal>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  open: PropTypes.bool,
  size: PropTypes.string,
  basic: PropTypes.bool,
};

Modal.defaultProps = {
  className: '',
  open: false,
  basic: false,
  size: '',
};

export default Modal;

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalBody = styled.div`
  position: relative;
  background-color: #fff;
  border: none;
  color: #000;
  text-align: left;
  width: 70%;
  margin: 0rem auto;
  border-radius: 7px;
  overflow-y: scroll;
  overflow-x: hidden;

  &.large {
    width: 80%;
  }

  &.full {
    width: 100%;
  }

  @media only screen and (max-width: 1200px) {
    width: 75%;
  }

  @media only screen and (max-width: 1000px) {
    width: 100%;
  }

  &.basic {
    width: 47rem;
    background-color: #fff;
    color: #000;
    padding: 0.75rem 1.5rem 0.75rem;
    left: 0;
    right: 0;

    .modal-actions {
      background-color: #fff;
    }
  }

  &.fullscreen {
    background-color: #fff;
    color: #000;
    margin: 2rem;
    padding: 0;
    width: 96%;
    color: black;
    background: white;
  }

  .modal-header {
    background-color: #fff;
    padding: 1.25rem 1.5rem;
    box-shadow: none;
    font-weight: 700;
    line-height: 1.3em;
    position: relative;

    .ui.header {
      margin-top: initial;
    }

    .close {
      position: absolute;
      top: 1.5rem;
      right: 2rem;
      font-size: 2rem;
      cursor: pointer;
      opacity: 0.7;

      &:hover {
        opacity: 1;
      }
    }
  }

  .modal-content {
    width: 100%;
    font-size: 1em;
    padding: 1.5rem;
    background-color: #fff;
  }

  .modal-actions {
    padding: 1rem;
    text-align: right;
    background: #f9fafb;
    border-top: 1px solid rgba(34, 36, 38, 0.15);
  }
`;
